var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBriefcase = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 10.6667H10.6667V10H5.33333V10.6667H4V10H1.33333V13.3333H14.6667V10H12V10.6667Z",
    fill: "#908CA0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 5.33333H11.3333V4C11.3333 3.26667 10.7333 2.66667 10 2.66667H6C5.26667 2.66667 4.66667 3.26667 4.66667 4V5.33333H2.66667C1.93333 5.33333 1.33333 5.93333 1.33333 6.66667V9.33333H4V8H5.33333V9.33333H10.6667V8H12V9.33333H14.6667V6.66667C14.6667 5.93333 14.0667 5.33333 13.3333 5.33333ZM10 5.33333H6V4H10V5.33333Z",
    fill: "#908CA0"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBriefcase);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/briefcase.bf79615ddcd76c6b2ad469caef0b1aea.svg";